import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCircleUpRight = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_11633_36177)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M1.55975 9.72604C0.9658 7.50193 1.54126 5.03049 3.28612 3.28563C5.88961 0.682134 10.1107 0.682134 12.7142 3.28563C15.3177 5.88913 15.3177 10.1102 12.7142 12.7137C10.9693 14.4586 8.49791 15.034 6.27379 14.4401M10.0003 9.99974V5.99974M10.0003 5.99974H6.00025M10.0003 5.99974L3.33346 12.6664",
			stroke: "#717680",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_11633_36177",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white"
		})
	}) })]
});
export default SvgCircleUpRight;
